import React from 'react'
function PrintErrorMsg({msg}) {
    return (
        <div className="shadow shadow-intensity-md rounded-3 mt-4 mb-4 py-4">
            <h5 className="text-center fs-14rem">{msg}</h5>
        </div>
    )
}
export default PrintErrorMsg;
